import React from "react";
import styled, { withTheme } from "styled-components";
import { ButtonTxtStyle } from "../Typography";
import ModuleBtnStyle from "./ModuleBtnStyle";

const StyledButton = styled.button`
  ${ModuleBtnStyle};
  background-color: ${({ theme }) => theme.colors.green2};
  &:hover {
    background-color: ${({ theme }) => theme.colors.green3};
  }
`;

const ButtonTxt = styled.p`
  ${ButtonTxtStyle}
  color: ${({ theme }) => theme.colors.green5};
`;

const ModuleBtn = ({
  className,
  children,
  buttonColor,
  textColor,
  theme,
  onClick
}) => (
  <StyledButton
    onClick={onClick}
    className={className}
    buttonColor={buttonColor}
  >
    <ButtonTxt color={textColor || theme.colors.green1}>{children}</ButtonTxt>
  </StyledButton>
);

ModuleBtn.defaultProps = {
  textColor: ({ theme }) => theme.colors.white
};

export default withTheme(ModuleBtn);
